import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';

// Se envia data archivo para subir a servidor
//UserId: id usuario logueado
export const SubirArchivosServidor = (adjunto) => {    
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Adjuntos/SubirArchivo/', {
            FileType: adjunto.FileType,
            FileContent: adjunto.FileContent,
            FileSize: adjunto.FileSize,
            FileName: adjunto.FileName,
            ObjectId: adjunto.ObjectId,
            FolderName: adjunto.FolderName,
            CompanyId: adjunto.CompanyId,
            UserId: adjunto.UserId
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se envia data archivo para subir a servidor
//FileName: nombre fichero
//FolderName: nombre carpeta
//ObjectId: id objeto
//CompanyId: id compañía usuario logueado
//UserId: id usuario logueado
export const BajarArchivosServidor = (adjunto) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Adjuntos/BajarArchivo/', {
            //FileType: adjunto.FileType,
            //FileContent: adjunto.FileContent,
            //FileSize: adjunto.FileSize,
            FileName: adjunto.FileName,            
            FolderName: adjunto.FolderName,
            ObjectId: adjunto.ObjectId,
            CompanyId: adjunto.CompanyId,
            UserId: adjunto.UserId
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se envia data archivo para bajar del servidor
//FileName: nombre fichero
//FolderName: nombre carpeta
//ObjectId: id objeto
//CompanyId: id compañía usuario logueado
//UserId: id usuario logueado
export const ObtenerArchivoImagen = (adjunto) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Adjuntos/ObtenerImagen/', {
            //FileType: adjunto.FileType,
            //FileContent: adjunto.FileContent,
            //FileSize: adjunto.FileSize,
            FileName: adjunto.FileName,            
            FolderName: adjunto.FolderName,
            ObjectId: adjunto.ObjectId,
            CompanyId: adjunto.CompanyId,
            UserId: adjunto.UserId
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};


// Se envia data archivo para eliminar a servidor
//FileName: nombre fichero
//FolderName: nombre carpeta
//ObjectId: id objeto
//CompanyId: id compañía usuario logueado
//UserId: id usuario logueado
export const EliminarArchivosServidor = (adjunto) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/Adjuntos/EliminarArchivo/', {            
            FileName: adjunto.FileName,            
            FolderName: adjunto.FolderName,
            ObjectId: adjunto.ObjectId,
            CompanyId: adjunto.CompanyId,
            UserId: adjunto.UserId
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};
